<template>
  <li
    :id="'task-' + task.id"
    class="
      draggable-item
      group
      hover:cursor-move
      p-4
      sm:p-5
      border-b border-borderColor-light
      dark:border-borderColor-dark
      flex flex-row
      items-center
    "
  >
    <div
      :class="[
        task.done ? 'bg-pattern' : '',
        'w-5 sm:w-6.1 h-5 sm:h-6.1 mr-3 sm:mr-5 flex items-center justify-center bg-borderColor-light dark:bg-borderColor-dark rounded-full hover:bg-pattern',
      ]"
    >
      <input
        :id="task.id"
        @change="$emit('change-status', task.id)"
        type="checkbox"
        :checked="task.done"
        name="status"
        class="
          w-4
          h-4
          sm:w-6
          sm:h-6
          rounded-full
          border-none
          bg-todoBackground-light bg-no-repeat bg-center
          dark:bg-todoBackground-dark
          cursor-pointer
          appearance-none
          checked:bg-check
        "
      />
      <label :for="task.id" class="sr-only">Task Status</label>
    </div>
    <span
      @click="$emit('change-status', task.id)"
      :class="[
        task.done
          ? 'text-todoTextDone-light dark:text-todoTextDone-dark line-through'
          : 'text-todoText-light dark:text-todoText-dark',
        'pt-0.5 sm:pt-1 box-border text-xs sm:text-lg font-normal font-josefin cursor-pointer flex-grow transition-all duration-300',
      ]"
      >{{ task.description }}</span
    >
    <button
      @click="$emit('delete-task', task.id)"
      :class="[
        task.done
          ? 'inline-block opacity-100 sm:hidden sm:opacity-0 sm:group-hover:inline-block sm:group-hover:opacity-100'
          : 'inline-block opacity-100 sm:hidden sm:opacity-0 sm:group-hover:inline-block sm:group-hover:opacity-100',
        'w-3 sm:w-6.1 h-3 sm:h-6.1 bg-delete bg-no-repeat bg-center transition-all duration-300',
      ]"
    >
      <span class="sr-only">Delete Task</span>
    </button>
  </li>
</template>
<script>
export default {
  name: "Task",
  props: {
    task: Object,
  },
};
</script>